import { render, staticRenderFns } from "./GroupsOverview.vue?vue&type=template&id=dee942c6&"
import script from "./GroupsOverview.vue?vue&type=script&lang=js&"
export * from "./GroupsOverview.vue?vue&type=script&lang=js&"
import style0 from "./GroupsOverview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports